import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { List, X, ArrowUpRight } from '@phosphor-icons/react';
import { motion, AnimatePresence } from 'framer-motion';
import { CATEGORIES } from '../../data/site';

const links = [
  { to: '/providers', label: 'For Providers' },
  { to: '/buyers', label: 'For Buyers' },
  { to: '/services', label: 'Services' },
  { to: '/directory', label: 'Directory' },
  { to: '/guides', label: 'Guides' },
  { to: '/advertise', label: 'Showcase' },
  { to: '/about', label: 'About' },
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/service-manager', label: 'Service Manager' },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <nav data-testid="site-nav" className="fixed inset-x-0 top-0 z-50 border-b border-line bg-ink/95 backdrop-blur-sm">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-10">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5" onClick={() => setOpen(false)}>
          <span className="flex h-6 w-6 items-center justify-center bg-volt font-display text-sm font-black text-ink">V</span>
          <span className="font-display text-sm font-bold tracking-[0.18em] text-parchment">VOX MERIDIAN</span>
        </Link>
        <div className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, '-')}`}
              className={({ isActive }) =>
                `font-mono text-xs font-semibold uppercase tracking-[0.2em] transition-colors duration-200 ${
                  isActive ? 'text-volt' : 'text-steel hover:text-parchment'
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/buyers"
            data-testid="nav-cta-post-rfq"
            className="group flex items-center gap-2 bg-volt px-4 py-2.5 font-mono text-xs font-bold uppercase tracking-[0.15em] text-ink transition-transform duration-200 hover:-translate-y-0.5 hover:bg-voltdark"
          >
            Post an RFQ
            <ArrowUpRight size={14} weight="bold" className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
        <button
          data-testid="nav-mobile-toggle"
          className="text-parchment md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden border-t border-line bg-ink md:hidden"
          >
            <div className="flex flex-col gap-1 px-6 py-6">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  className="py-3 font-mono text-sm font-semibold uppercase tracking-[0.2em] text-steel"
                >
                  {l.label}
                </NavLink>
              ))}
              <div className="mt-2 border-t border-line pt-4">
                {CATEGORIES.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/services/${c.slug}`}
                    onClick={() => setOpen(false)}
                    className="block py-3 text-sm text-steel"
                  >
                    {c.name}
                  </Link>
                ))}
              </div>
              <Link
                to="/buyers"
                onClick={() => setOpen(false)}
                className="mt-4 flex items-center justify-center gap-2 bg-volt px-4 py-3 font-mono text-xs font-bold uppercase tracking-[0.15em] text-ink"
              >
                Post an RFQ <ArrowUpRight size={14} weight="bold" />
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};
